import { useTranslation } from 'react-i18next';

import type { TabsNavigation } from '@/types/ui';

import {
  TABS_TRIGGER_CLASS_NAME,
  tabsListVariants,
} from '@/components/ui/tabs';

export const PageTabs = (props: TabsNavigation) => {
  const { tabs } = props;

  const { t } = useTranslation();

  if (!tabs?.length) {
    return null;
  }

  return (
    <nav
      data-variant="line"
      className={tabsListVariants({ variant: 'line', className: 'mb-4' })}
    >
      {tabs.map((tab) => (
        <a
          key={tab.href}
          href={tab.href}
          data-state={tab.active ? 'active' : 'inactive'}
          aria-current={tab.active ? 'page' : undefined}
          className={TABS_TRIGGER_CLASS_NAME}
        >
          {t(tab.text)}
        </a>
      ))}
    </nav>
  );
};
